<template>
    <modal @close="cancelClick" class="edit-modal" hide-footer id="add-api-key">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Add API Key</h3>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Add API Key</h3>
                    <div class="md-col-2">
                        <div class="column">

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Name:</label>
                                <input class="td-input" v-model="add.name" type="text" placeholder="" />
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold">Redirect URL:</label>
                                <input class="td-input" v-model="add.redirectUrl" type="text" placeholder="" />
                            </div>
                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="cancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="saveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './AddApiKey';
    export default script;
</script>

<style lang="less">
    @import './AddApiKey.less';
</style>